

export default {
    vi : {
        header: 'Đăng ký tài khoản',
        description: 'Nhập email của bạn để nhận mã xác thực đăng ký tài khoản mới',
        email: 'Nhập email của bạn',
        invalidEmail: 'Email không hợp lệ',
        login: 'Quay lại đăng nhập',
        others: 'Hoặc đăng ký với'
    },
    en: {
        header: 'Register new account',
        description: 'Enter your email to receive verification code for registering your new account',
        email: 'Enter your email',
        invalidEmail: 'Email is invalid',
        login: 'Back to login',
        others: 'Register with other options'
    }
};
